<!--
 * @Author: wsx
 * @Date: 2022-01-13 16:02:02
 * @LastEditTime: 2022-01-14 10:59:57
 * @LastEditors: your name
 * @Description:字段权限
-->
<template>
  <div class='TabsField'>
    <template v-for="item in list" :key="item">
      <el-card class="field-card">
        <template #header>
          <span>{{item.title}}</span>
        </template>
        <table class="tabs-field-table">
          <tr class="tabs-field-table-item">
            <template v-for="f in item.fields" :key="f.field">
              <td >
                <el-checkbox v-model="f.value" size="large">{{f.name}}</el-checkbox>
              </td>
            </template>
          </tr>
        </table>
      </el-card>
    </template>
  </div>
</template>
<script >
import {
  defineComponent,
  reactive,
  toRefs,
  watch
} from 'vue';
export default defineComponent({
  name: 'TabsField',
  components: {},
  props: {
    role: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const state = reactive({
      list: [
        {
          title: "实有人口",
          fields: [
            { name: "姓名", field: 'name', value: true },
            { name: "性别", field: 'sex', value: true },
            { name: "年龄", field: 'age', value: true },
            { name: "身份证号", field: 'IDCard', value: true },
            { name: "角色", field: 'role', value: true },
            { name: "部门", field: 'department', value: true }
          ]
        }, {
          title: "实有房屋",
          fields: [
            { name: "房主姓名", field: 'name', value: true },
            { name: "性别", field: 'sex', value: true },
            { name: "年龄", field: 'age', value: true },
            { name: "身份证号", field: 'IDCard', value: true },
            { name: "角色", field: 'role', value: true },
            { name: "部门", field: 'department', value: true }
          ]
        }
      ]
    });
    const refData = toRefs(state);
    watch(() => props.role, () => {
      // 选中角色变化重新加载数据
    });
    return { ...refData };
  }
});
</script>
<style  lang='scss' scoped >
.TabsField {
  width: 100%;
  height: 100%;
  overflow: auto;
  .field-card{
    margin-bottom: 15px;
  }
  .tabs-field-table{
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid var(--el-border-color-base);
    border-bottom: none;
    border-right: none;
    .tabs-field-table-item{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
        td{
          padding-left: 10px;
          border: 1px solid var(--el-border-color-base);
          border-top: none;
          width: 25%;
          &:first-child{
            border-left: none;
          }
        }
      }
  }
}
</style>